export const frontmatter = {
    "draft": true,
    "title": "Google Integration",
    "description": "Authentication and access to OnnIA using a Google account.",
    "sidebar_label": "Google",
    "sidebar_group": "guides",
    "sidebar_order": 4
}

export const toc = []